var map = {
	"./bamboo hat.png": 9942,
	"./birthday hat.png": 1949,
	"./blank.png": 106,
	"./cap.png": 5052,
	"./chef cap.png": 8687,
	"./cowboy hat.png": 338,
	"./degree hat.png": 772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7132;